import { render, staticRenderFns } from "./normSearch.vue?vue&type=template&id=87be97ae&"
import script from "./normSearch.vue?vue&type=script&lang=js&"
export * from "./normSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports